import React, {useState} from 'react';
import {
  DialogContent,
  DialogActions,
  Dialog,
  Card,
  CardHeader,
  CardContent,
  // CardActions,
  Divider,
  Grid,
  // TextField,
  Button,
  // Typography,
} from '@material-ui/core';

import {Bookmark, HowToReg, PersonAdd, CloudDone} from '@material-ui/icons'

import { postApplyToOfferAPIReq, postAddFavoriteAPIReq, getFavoritesAPIReq, deleteFavoriteAPIReq } from 'utils/requests'
import PropTypes from 'prop-types';
import MuiAlert from '@material-ui/lab/Alert';
import {AlertTitle} from '@material-ui/lab'
import Snackbar from '@material-ui/core/Snackbar';
import ActionGroup from '../ActionGroup';

import moment from 'moment';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

function Alert(props) {
  return <MuiAlert
    elevation={6}
    variant="filled"
    {...props}
         />;
}

const CreateApplication = (props) => {

  const { className, offer, ...rest } = props;

  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState('');
  const [isFavorite, setisFavorite] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const addFavorite = (id) => {
    // console.log(id)
    return postAddFavoriteAPIReq(id).then((res) => {
      if (res.status === 'success'){
        setisFavorite(true)
      } else if (res.status === 'fail'){
        setOpenErrorSnack(true);
      }
    }).catch((err) => {
      setOpenErrorSnack(true);
    })
  }

  const checkFav = (offer_id) => {
    return getFavoritesAPIReq()
      .then((res) => {
        if (res.status === 'success'){
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].hashed_id === offer_id){
              setisFavorite(true)
              break;
            } else {
              setisFavorite(false)
            }
          
          }
        }
      })
  }

  const removeFav = (offer_id) => {
    return deleteFavoriteAPIReq(offer_id)
      .then((res) => {
        if (res.status === 'success'){
          setisFavorite(false)
        }
      })
  }

  if (offer){
    checkFav(offer.hashed_id);
  }

  const handleChange = (event) => {
    setValue(event.target.value);

    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };
  const [openErrorSnack, setOpenErrorSnack] = React.useState(false);
  const [openSuccessSnack, setOpenSuccessSnack] = React.useState(false);

  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState('md');
  const [reload, setReload] = React.useState(0);
  const [editorState, setEditorState] = React.useState(EditorState.createEmpty());
  const handleCloseSuccessSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSuccessSnack(false);
  };

  const handleCloseErrorSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenErrorSnack(false);
  };


  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  function handleSubmit(event) {
    event.preventDefault();

    return postApplyToOfferAPIReq(offer, draftToHtml(convertToRaw(editorState.getCurrentContent())))
      .then((isSuccess) => {
        if(isSuccess === true) {
          setOpenSuccessSnack(true);
          setOpen(false);
          offer.didApply = true;
          setReload(reload + 1);
        }
        else
          setOpenErrorSnack(true);
      })

  }

  function onEditorStateChange(editorState){
    // console.log(draftToHtml(convertToRaw(editorState.getCurrentContent())))
    setEditorState(editorState);
  }

  return (
    <div>
      <div>
        <MuiAlert severity="warning">
          <AlertTitle>{'Deadline: ' + moment(offer.end_date).format('MMMM DD, YYYY hh:mm a')}</AlertTitle>
        Offer published on {moment(offer.posted_date).format('MMMM DD, YYYY hh:mm a')}
        </MuiAlert>
      </div>
      <br />

      <div >
        {
          (offer.didApply)?
            <Button
              color="primary"
              disabled
              startIcon={<HowToReg />}
              variant="contained"
            >
            Applied
            </Button>
            :<Button
              color="primary"
              onClick={handleClickOpen}
              startIcon={<PersonAdd />}
              variant="contained"
            >

            Apply Now
            </Button>

        }
        <br />
        <br />
        {
          (isFavorite)?
            <Button
              color="secondary"
              onClick={() => removeFav(offer.hashed_id)}
              startIcon={<CloudDone />}
              variant="contained"
            >
            Saved for later
            </Button>
            :<Button
              color="primary"
              onClick={() => addFavorite(offer.hashed_id)}
              startIcon={<Bookmark />}
              variant="contained"
            >
            Save for later
            </Button>
          
        }

        <Dialog
          aria-describedby="scroll-dialog-description"
          aria-labelledby="scroll-dialog-title"
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          onClose={() => props}
          open={open}
          scroll={'paper'}
        >

          <DialogContent dividers>
            <Card >
              <form
                autoComplete="off"
                noValidate
                onSubmit={handleSubmit}
              >
                <CardHeader
                  title="Write your motivation Letter"
                />
                <Divider />
                <CardContent>
                  <Grid
                    container
                    spacing={3}
                  >
                    <Grid
                      container
                      spacing={3}
                    >
                      <Grid
                        item
                        md={12}
                        xs={12}
                      >
                        <Editor
                          editorClassName="editorClassName"
                          editorState={editorState}
                          onEditorStateChange={onEditorStateChange}
                          toolbar={{
                            options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link', 'remove', 'history'],
                            inline: {
                              options: ['bold', 'italic', 'monospace'],
                            },
                          }}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                        />
                        {/*<TextField*/}
                        {/*  fullWidth*/}
                        {/*  id="outlined-multiline-static"*/}
                        {/*  label="Motivation Letter"*/}
                        {/*  margin="dense"*/}
                        {/*  multiline*/}
                        {/*  name="motivationLetter"*/}
                        {/*  onChange={handleChange}*/}
                        {/*  required*/}

                        {/*  variant="outlined"*/}
                        {/*/>*/}
                      </Grid>

                    </Grid>
                  </Grid>
                </CardContent>
                <Divider />
              </form>
            </Card>
          </DialogContent>
          <DialogActions>
            <Button
              color="white"
              onClick={() => setOpen(false)}
              variant="contained"
            >
          Cancel
            </Button>
            <Button
              color="primary"
              onClick={
                handleSubmit
              }
              type="submit"
              variant="contained"
            >
          Submit
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          autoHideDuration={6000}
          onClose={handleCloseErrorSnack}
          open={openErrorSnack}
        >
          <Alert
            onClose={handleCloseErrorSnack}
            severity="error"
          >
          An Error Has Occurred
          </Alert>
        </Snackbar>
        <Snackbar
          autoHideDuration={6000}
          onClose={handleCloseSuccessSnack}
          open={openSuccessSnack}
        >
          <Alert
            onClose={handleCloseSuccessSnack}
            severity="success"
          >
          Application Sent Successfully
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

ActionGroup.propTypes = {
  className: PropTypes.string,
  offer: PropTypes.object.isRequired
};

export default CreateApplication;
